import { LeadModel } from '../model/lead.model';

const LEAD_INDUSTRY = ['RETAIL', 'MANUFACTURING', 'WHOLESALE', 'TRANSPORT', 'FB', 'HOSPITALITY', 'SERVICES', 'CONSTRUCTION'] as const;
export type LeadIndustry = typeof LEAD_INDUSTRY[number];
export const LeadIndustry: Record<LeadIndustry, LeadIndustry> = {
  CONSTRUCTION: 'CONSTRUCTION',
  FB: 'FB',
  HOSPITALITY: 'HOSPITALITY',
  MANUFACTURING: 'MANUFACTURING',
  RETAIL: 'RETAIL',
  SERVICES: 'SERVICES',
  TRANSPORT: 'TRANSPORT',
  WHOLESALE: 'WHOLESALE',
} as const;

const LEAD_SALUTATION = ['MR', 'MRS', 'MS', 'DR', 'MDM'] as const;
export type LeadSalutation = typeof LEAD_SALUTATION[number];
export const LeadSalutation: Record<LeadSalutation, LeadSalutation> = {
  DR: 'DR',
  MDM: 'MDM',
  MR: 'MR',
  MRS: 'MRS',
  MS: 'MS',
} as const;

const LEAD_BUSINESS_TYPE = [
  'SOLE_PROPRIETORSHIP',
  'PARTNERSHIP',
  'LIMITED_PARTNERSHIP',
  'LIMITED_LIABILITY_PARTNERSHIP',
  'EXEMPT_PRIVATE_COMPANY',
] as const;
export type LeadBusinessType = typeof LEAD_BUSINESS_TYPE[number];
export const LeadBusinessType: Record<LeadBusinessType, LeadBusinessType> = {
  EXEMPT_PRIVATE_COMPANY: 'EXEMPT_PRIVATE_COMPANY',
  LIMITED_LIABILITY_PARTNERSHIP: 'LIMITED_LIABILITY_PARTNERSHIP',
  LIMITED_PARTNERSHIP: 'LIMITED_PARTNERSHIP',
  PARTNERSHIP: 'PARTNERSHIP',
  SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
} as const;

const PREFERRED_CONTACT_MODE = ['SMS', 'EMAIL', 'PHONE'] as const;
export type PreferredContactMode = typeof PREFERRED_CONTACT_MODE[number];
export const PreferredContactMode: Record<PreferredContactMode, PreferredContactMode> = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  SMS: 'SMS',
} as const;

export type LeadSubmissionResponse = {
  id: number;
  uuid: string;
  status: string;
  leadId: number;
  contactEmail: string;
  contactPhoneAreaCode: string;
  contactPhoneNumber: string;
  body: LeadModel;
  metadata: null;
  createdAt: string;
  updatedAt: string;
};
